<template>
  <div>
    <div v-if="!file">
      <div 
        :class="['dropzone', dragging ? 'dropzone--over' : '']" 
        @dragenter="dragging = true" 
        @dragleave="dragging = false"
      >
        <div class="dropzone__info" @drag="onChange">
          <span class="dropzone__title h5">Drag&amp;Drop</span>
          <div class="dropzone__upload-limit-info">ziehen Sie hier Ihre Datei rüber, um sie hochzuladen</div>
        </div>
        <input type="file" @change="onChange" class="dropzone__input">
      </div>
    </div> 

    <div v-else class="dropzone__uploaded">
      <div class="dropzone__uploaded-info">
        <span class="dropzone__title">{{ file.name }} ({{ (file.size / (1024*1024)).toFixed(2) }} MB)</span>
        <button type="button" class="btn btn-primary dropzone__remove-file" @click="removeFile">
          Remove File <i class="icon icon-Actions---Operations---delete---24"></i>
        </button>
      </div> 
    </div>

    <div class="dropzone__caption">PNG, JPG SVG-Dateien akzeptiert</div>
</div>
</template>
<script>
export default {
  data() {
    return {
      file: "",
      dragging: false,
    };
  },
  computed: {
    extension() {
      return this.file ? this.file.name.split(".").pop() : "";
    },
  },
  methods: {
    onChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        this.dragging = false;
        return;
      }

      this.createFile(files[0]);
    },
    createFile(file) {
      this.file = file;
      this.dragging = false;
    },
    removeFile() {
      this.file = "";
    },
  },
};
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
</style>